import { Controller } from "@hotwired/stimulus";
import ToastService from "../../shared/toast_service";
import * as Sentry from "@sentry/browser";

/**
 * Share Controller
 *
 * Handles triggering the native share functionality on mobile devices.
 *
 * @example
 * ```ruby
 * button data: {
 *   controller: "share",
 *   action: "click->share#share",
 *   share_title_value: "Menu Title",
 *   share_text_value: "Check out this menu!",
 *   share_url_value: "https://example.com/menu"
 * }
 * ```
 */
export default class extends Controller {
  static values = {
    title: String,
    text: String,
    url: String,
    errorMessage: {
      type: String,
      default: `Oops! Something went wrong while sharing the menu. 
        We have been notified and will fix it soon.`,
    },
    copiedToClipboardMessage: {
      type: String,
      default: "Copied to clipboard",
    },
    sharingMessage: {
      type: String,
      default: "Thanks for sharing!",
    },
  };

  share() {
    if (navigator.share) {
      new ToastService().success({
        text: this.sharingMessageValue,
      });
      navigator
        .share({
          title: this.titleValue,
          text: this.textValue,
          url: this.urlValue,
        })
        .catch((error) => {
          // Don't show error or capture in Sentry if user cancelled sharing
          if (error.code === 20) return;

          new ToastService().alert({
            text: this.errorMessageValue,
          });
          Sentry.captureException(error);
        });
    } else {
      navigator.clipboard.writeText(this.urlValue);
      new ToastService().alert({
        text: this.copiedToClipboardMessageValue,
      });
    }
  }
}
